/* eslint-disable no-underscore-dangle */
// Ignored the underscore-dangle rule to define __ private vars in window scope
/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import Worker from './swagger.worker.js';
/**
 * `__swaggerWorker` & `__swaggerSpec` are used to pass the worker object and
 * parsed swagger object to APIClient constructor
 */
window.__swaggerWorker = new Worker();
window.__swaggerWorker.onmessage = (e) => {
    window.__swaggerSpec = e.data;
};
